/**
 * LocalStorageDeviceIdProvider
 * Layer: infrastructure (attendance module)
 *
 * Implements IDeviceIdProvider by reading the enrolled device id from
 * localStorage. The key 'mi_enrolled_device_id' is written by
 * deviceMutations.persistDeviceId() after a successful enrollment.
 *
 * Returns null when:
 *  - the key does not exist in localStorage
 *  - the stored value is an empty string
 *
 * Design: correcto-registro-de-timelogs-locales-y-remotos (D1)
 */
import type { IDeviceIdProvider } from '../../domain/ports/IDeviceIdProvider';

const ENROLLED_DEVICE_KEY = 'mi_enrolled_device_id';
const ENROLLED_DEVICE_SERIAL_KEY = 'mi_enrolled_device_serial';

export class LocalStorageDeviceIdProvider implements IDeviceIdProvider {
  getDeviceId(): string | null {
    const raw = localStorage.getItem(ENROLLED_DEVICE_KEY);
    if (raw === null || raw === '') return null;
    return raw;
  }

  getSerial(): string | null {
    const raw = localStorage.getItem(ENROLLED_DEVICE_SERIAL_KEY);
    if (raw === null || raw === '') return null;
    return raw;
  }
}
